import { render, staticRenderFns } from "./InformationMassagePush.vue?vue&type=template&id=2ebb9034&scoped=true"
import script from "./InformationMassagePush.vue?vue&type=script&lang=js"
export * from "./InformationMassagePush.vue?vue&type=script&lang=js"
import style0 from "./InformationMassagePush.vue?vue&type=style&index=0&id=2ebb9034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb9034",
  null
  
)

export default component.exports